import {
  FormControlLabel as UnstyledFormControlLabel,
  styled,
} from "@mui/material";

interface FormControlLabelProps {
  fullWidth?: boolean;
}

export const FormControlLabel = styled(UnstyledFormControlLabel, {
  shouldForwardProp: (propName: keyof FormControlLabelProps) =>
    propName !== "fullWidth",
})<FormControlLabelProps>(({ fullWidth }) =>
  fullWidth
    ? {
        display: "flex",
      }
    : null,
);
